"use client";

import { useEffect } from "react";

import type { CommerceEventBaseData } from "@jti/tracker";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { useGTMInitState } from "@/context/GTMContext";

type Props = { data: Omit<CommerceEventBaseData, "value"> };

export const ViewItemListEventDispatcher = ({ data }: Props) => {
  const { isGTMInitialized } = useGTMInitState();

  useEffect(() => {
    if (!isGTMInitialized) return;
    dispatchTrackingEvent(TrackingEvents.TrackingViewItemList, data);
  }, [isGTMInitialized, data]);

  return null;
};
